import http from "./AxiosInstance";

class BilanService {
  getBenefices(periode, dateSpecifique = null) {
    const params = dateSpecifique ? { date_specifique: dateSpecifique } : {};
    return http.get(`/bilan/benefices/${periode}`, { params });
  }

  getBeneficesDetail(dateDebut, dateFin) {
    return http.get('/bilan/benefices/detail', {
      params: { date_debut: dateDebut, date_fin: dateFin }
    });
  }

  getBilanQuotidienAuto() {
    return http.get('/bilan/quotidien/auto');
  }

  getBonsClients(periode) {
    return http.get('/bilan/bons-clients', {
      params: { periode: periode }
    });
  }
}

const bilanService = new BilanService();
export default bilanService;